<template>
<div>
    <!-- Old code -->
    <!-- <div class="wrp-rb d-flex flex-column align-items-center">
        <transition name="custom-classes-transition" enter-active-class="animated fadeInUp faster" leave-active-class="animated fadeOutDown faster">
            <div v-show="flagOpen" class="rb-group">
                <b-link @click="goTo('contact')" class="btn-circle"><img src="@/assets/images/rb-icon-contact.svg"></b-link>
                <b-link @click="goTo('invoice')" class="btn-circle"><img src="@/assets/images/rb-icon-invoice.svg"></b-link>
                <b-link @click="goTo('item')" class="btn-circle"><img src="@/assets/images/rb-icon-item.svg"></b-link>
            </div>
        </transition>
        <img class="btn-rb" :class="{ 'btn-close': flagOpen }" src="@/assets/images/rb-icon-add.svg" @click="toggleFlagOpen" style="height:55px">
    </div>
    <div v-show="flagOpen" class="container-overlay" @click="toggleFlagOpen"></div> -->

    <!-- New Vue Material Speed Dial -->
    <md-speed-dial class="md-bottom-right md-fixed"  md-event="click" v-if="current_route == 'contact'">
      <md-speed-dial-target class="md-primary" @click="updateSpeedDialContact">
        <md-icon class="md-morph-initial">add</md-icon>
        <md-icon class="md-morph-final">close</md-icon>
      </md-speed-dial-target>

      <md-speed-dial-content>
        <md-button class="md-icon-button" @click="goToCreatePerson" id="fab_person">
          <md-icon>person_add</md-icon>
        </md-button>

        <md-button class="md-icon-button" @click="goToCreateBusiness" id="fab_business">
          <md-icon>domain</md-icon>
        </md-button>
      </md-speed-dial-content>

        <b-tooltip target="fab_person" title="Person" :show.sync="fab_contact_show" placement="left"></b-tooltip>
        <b-tooltip target="fab_business" title="Business" :show.sync="fab_contact_show" placement="left"></b-tooltip>
    </md-speed-dial>

    <md-speed-dial class="md-bottom-right md-fixed" md-event="click" v-else-if="current_route == 'invoice'">
        <md-speed-dial-target class="md-primary" @click="updateSpeedDialInvoice">
            <md-icon class="md-morph-initial">add</md-icon>
            <md-icon class="md-morph-final">close</md-icon>
        </md-speed-dial-target>

        <md-speed-dial-content>
            <md-button class="md-icon-button md-raised" @click="goToCreateInvoice" id="fab_invoice">
                <md-icon class="md-primary" :md-src="require('@/assets/images/fab_invoices.svg')"/>
            </md-button>

            <!--<md-button class="md-icon-button" @click="goToCreateBusiness" id="fab_contact">-->
                <!--<md-icon class="md-primary" :md-src="require('@/assets/images/fab_contacts.svg')" />-->
            <!--</md-button>-->

            <!--<md-button class="md-icon-button" @click="goToCreateItem" id="fab_item">-->
                <!--<md-icon class="md-primary" :md-src="require('@/assets/images/fab_items.svg')" />-->
            <!--</md-button>-->
        </md-speed-dial-content>

        <b-tooltip class="fab_tooltip" target="fab_invoice" title="Invoices" :show.sync="fab_invoice_show" placement="left"></b-tooltip>
        <b-tooltip target="fab_contact" title="Contacts" :show.sync="fab_invoice_show" placement="left"></b-tooltip>
        <!--<b-tooltip target="fab_item" title="Items" :show.sync="fab_invoice_show" placement="left"></b-tooltip>-->
    </md-speed-dial>

    <md-speed-dial class="md-bottom-right md-fixed" v-else>
        <md-speed-dial-target class="md-primary" @click="goToPage">
            <md-icon class="md-morph-initial">add</md-icon>
            <md-icon class="md-morph-final">close</md-icon>
        </md-speed-dial-target>
    </md-speed-dial>

    <div class="overlaySpeedDial" v-if="current_route == 'contact' && fab_contact_show"></div>
    <div class="overlaySpeedDial" v-else-if="current_route == 'invoice' && fab_invoice_show"></div>

</div>
</template>

<script>
export default {
    props: {
      thepage: String,
    },
    data() {
        return {
            flagOpen: false,
            fab_invoice_show: false,
            fab_contact_show: false,
        }
    },
    methods: {
        goTo(name) {
            document.querySelector('body').classList.remove('modal-open')
            this.$router.push({
                name: name,
                cat: 'All'
            })
        },
        toggleFlagOpen() {
            this.flagOpen = !this.flagOpen
            this.toggleBody()
        },
        toggleBody() {
            document.querySelector('body').classList.toggle('modal-open')
        },
        goToPage() {
          if(this.$route.name == 'invoice' && this.$route.params.cat == 'all') {
            this.$store.dispatch('clearSelectedContact')
            this.$store.dispatch('clearSelectedDepositToContact')
            this.$store.dispatch('clearItems')
          }
          this.$router.push(this.thepage)
        },
        goToCreatePerson() {
          this.$router.push('/create_person')
        },
        goToCreateBusiness() {
          this.$router.push('/create_business')
        },
        goToCreateItem() {
            this.$router.push('/create_item')
        },
        goToCreateInvoice() {
            this.$router.push('/create_invoice')
        },
        updateSpeedDialInvoice() {
            this.fab_invoice_show = !this.fab_invoice_show;
        },
        updateSpeedDialContact() {
            this.fab_contact_show = !this.fab_contact_show;
        },
    },
    computed: {
      current_route() {
        return this.$route.name
      }
    }
}
</script>

<style lang="scss">
    .md-button-content svg {
        vertical-align: top !important;
        height: 19px !important;
        width: 19px !important;
    }
    .tooltip {
        top: -20px !important;
        left: -5px !important;
    }
    .tooltip .arrow {
        display: none !important;
    }
    .tooltip-inner {
        background-color: #e7e6e6 !important;
        border-color: #c7c7c7 !important;
        border-style: solid;
        border-width: 1px;
        color: #000000 !important;
    }
</style>
